const CAN_USE_DOM = typeof window !== 'undefined';

enum Share {
  'facebook',
  'whatsApp',
  'twitter',
}

export type ShareType = keyof typeof Share;

export const share = (type: ShareType) => {
  if (!CAN_USE_DOM) {
    return;
  }

  const domain = window.location.href;
  const titleProp = document.querySelector('meta[property="og:title"]');
  const title = titleProp ? titleProp.getAttribute('content') : '';
  const descriptionProp = document.querySelector('meta[property="og:description"]');
  const description = descriptionProp ? descriptionProp.getAttribute('content') : '';
  const encode = encodeURIComponent;
  const isMobile = !!window.ontouchstart && window.matchMedia('(max-width: 1024px)').matches;
  const text = `${title}\n${description}\n${domain}`;

  if (type === 'facebook') {
    const fbURL = 'https://www.facebook.com/sharer.php?u=';

    window.open(`${fbURL}${domain}`, 'sharer', 'width=555,height=600');
  }

  if (type === 'whatsApp') {
    const waShareLink = `https://wa.me/?text=${encode(`${text}`)}`;
    if (!isMobile) {
      window.open(waShareLink, '_blank');
    } else {
      window.location.href = waShareLink;
    }
  }

  if (type === 'twitter') {
    console.log('text', text);
    const twURL = 'https://twitter.com/intent/tweet?url=';
    const twText = `${title}\n${description}`;
    const finalURL = `${twURL}${domain}&text=${encode(`${twText}`)}`;

    const shareWindow = window.open(finalURL, 'ShareOnTwitter', 'width=555,height=600');
    if (shareWindow) shareWindow.opener = null;
  }
};
